export default __webpack_public_path__ + "static/left-side-img-314320f75aca785d84177ca89a33bd79.png";